import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Section from "../components/Section";
import { Projects } from "../Data/Data";
import { delayNavigation } from "../helpers/helpers";
import { useDispatch } from "react-redux";

const ProjectsList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [scrollY, setScrollY] = useState(0);
  /* const [isLargeScreen, setIsLargeScreen] = useState(false); */

  // Update the scroll position state
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY); // Capture the vertical scroll position
    };

    /* const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 1500);
    }; */

    window.addEventListener("scroll", handleScroll);
    /* window.addEventListener("resize", handleResize); */

    // Initial check
    /* handleResize(); */

    return () => {
      window.removeEventListener("scroll", handleScroll);
      /* window.removeEventListener("resize", handleResize); */
    };
  }, []);

  return (
    <div className="relative pt-20">
      <Section bg="bg-inherit">
        <div className="col-span-10 col-start-2">
          <h2 className="text-primary-dark font-gilroy text-4xl xl:text-6xl tracking-wider col-span-11 py-24 leading-4">
            პროექტები
          </h2>
          <div className="h-[2px] bg-black opacity-30 " />
        </div>
        <div className="py-8 col-span-full flex flex-col gap-14">
          {Projects.map((project) => {
            return (
              <div
                key={project.id}
                className="relative w-full h-56 md:h-[650px] bg-inherit "
                onClick={() => {
                  delayNavigation(
                    dispatch,
                    navigate,
                    `/projects/${project.name}`
                  );
                }}
              >
                <div className="absolute flex flex-col items-center justify-center text-primary-light inset-0 h-full w-full z-10 ">
                  <p className="my-4 max-w-2xl font-gilroy text-lg tracking-wider text-primary-bg-green">
                    {project.status}
                  </p>
                  <p className="my-4 px-6 md:p-0 max-w-2xl text-sm md:text-xl tracking-wider font-semibold">
                    {project.addressfull}
                  </p>
                  <h2 className="text-2xl md:text-5xl font-gilroy tracking-wider mb-4">
                    {project.label}
                  </h2>

                  <a
                    href={`/projects/${project.name}`}
                    onClick={(event) => {
                      delayNavigation(
                        dispatch,
                        navigate,
                        `/projects/${project.name}`,
                        event
                      );
                    }}
                    className="relative uppercase text-xs md:text-lg font-bold tracking-wider  bg-transparent no-underline opacity-100 transform transition-all duration-[0.45s] ease-out delay-[0.6s] flex flex-col justify-center items-center whitespace-nowrap cursor-pointer group"
                  >
                    აღმოაჩინე მეტი
                    <span className="bottom-0 left-0 h-[2px] bg-primary-light w-0 transition-all duration-500 group-hover:w-full z-10 "></span>
                  </a>
                </div>
                <div className="w-full inset-0 overflow-hidden bg-black h-full flex items-center justify-center ">
                  <img
                    src={project.listImg}
                    alt="Promo Background"
                    className={` opacity-50 inline-block max-w-full w-full h-[450px] md:h-[1050px] text-center align-middle object-cover`}
                    style={{
                      transform: `translateY(-${scrollY * 0.1}px)`,
                      transition: "transform 1s",
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </Section>
    </div>
  );
};

export default ProjectsList;
